// extracted by mini-css-extract-plugin
module.exports = {"title_ad":"title_ad-2kUCtiXN"};